import React from "react";
import { Button, Img, Text } from "..";
import { default as ModalProvider } from "react-modal";

export default function ModalOnBoard({ isOpen, onClose, item }) {
  if (!item) return null;

  const formatDate = (dateString) => {
    try {
      return new Date(Date.parse(dateString)).toLocaleDateString();
    } catch (error) {
      return dateString;
    }
  };

  return (
    <ModalProvider
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        overlay: {
          backgroundColor: isOpen ? "#D9D9D9CC" : "transparent",
        },
        content: {
          outline: "none",
        },
      }}
      appElement={document.getElementById("root")}
      className="w-[45%]" // Mirip pendekatan di DetailsModal
    >
      {/* Konten modal mirip DetailsModal */}
      <div className="flex flex-col items-start justify-center w-full p-4 gap-2 bg-white-A700 rounded-[10px]">
        <Text
          size="xl"
          as="p"
          className="text-center !text-blue_gray-700 !font-bold w-full"
        >
          Issuer Detail
        </Text>
        <div className="grid grid-cols-2 gap-2 w-full mt-4">
          <Text as="p" className="!text-blue_gray-700 !font-semibold">
            ID
          </Text>
          <Text as="p" className="!text-blue_gray-700">
            {item.id}
          </Text>
          <Text as="p" className="!text-blue_gray-700 !font-semibold mt-2">
            Name
          </Text>
          <Text as="p" className="!text-blue_gray-700 mt-2">
            {item.name}
          </Text>
          <Text as="p" className="!text-blue_gray-700 !font-semibold mt-2">
            Address
          </Text>
          <Text as="p" className="!text-blue_gray-700 mt-2">
            <Text as="p">
              {item.address}
            </Text>
            <Text as="p" className="mt-2">
              {item.email}
            </Text>
            <Text as="p" className="mt-2">
              {item.phone}
            </Text>
          </Text>
          <Text as="p" className="!text-blue_gray-700 !font-semibold mt-2">
            On Board Date
          </Text>
          <Text as="p" className="!text-blue_gray-700 mt-2">
            {formatDate(item.updated_at)}
          </Text>
          <Text as="p" className="!text-blue_gray-700 !font-semibold mt-2">
            Bank Name
          </Text>
          <Text as="p" className="!text-blue_gray-700 mt-2">
            {item.bank_name}
          </Text>
          <Text as="p" className="!text-blue_gray-700 !font-semibold mt-2">
            Bank Account Name
          </Text>
          <Text as="p" className="!text-blue_gray-700 mt-2">
            {item.bank_account_name}
          </Text>
          <Text as="p" className="!text-blue_gray-700 !font-semibold mt-2">
            Bank Account Number
          </Text>
          <Text as="p" className="!text-blue_gray-700 mt-2">
            {item.bank_account_number}
          </Text>
          <Text as="p" className="!text-blue_gray-700 !font-semibold mt-2">
            License Number
          </Text>
          <Text as="p" className="cursor-pointer underline mt-2">
            <a
              href={item.registration_number_file}
              target="_blank"
              className="flex items-center gap-1"
            >
              <Img
                src="images/img_carbon_view.svg"
                alt="view-file"
                className="h-4 w-4"
              />
              {item.registration_number}
            </a>
          </Text>
          <Text as="p" className="!text-blue_gray-700 !font-semibold mt-2">
            Status
          </Text>
          <Text as="p" className="!text-blue_gray-700 mt-2">
            {item.status}
          </Text>
        </div>
        <div className="w-full flex justify-end">
          <Button
            onClick={onClose}
            color="gray_100_01"
            size="sm"
            className="uppercase !text-xs font-bold !rounded-xl mt-2"
          >
            Close
          </Button>
        </div>
      </div>
    </ModalProvider>
  );
}
